import get from 'lodash/get';
import trim from 'lodash/trim';

const getDeliveryDateType = (text) =>
    /\w+\s\d+\w+\s-\s\w+\s\d+\w+/.test(text) ? 'range' : 'single';

const getAvailabilityStatus = (shipToHomeOrStore) => {
    const availabilityStatus = get(
        shipToHomeOrStore,
        'shipToHomeAvailability.availabilityStatus',
        ''
    );
    let setAvailabilityMessage = '';
    switch (availabilityStatus) {
        case 'AL':
            setAvailabilityMessage = 'limited stock available';
            break;
        case 'AH':
            setAvailabilityMessage = 'in stock';
            break;
        case 'NA':
            setAvailabilityMessage = 'out of stock';
            break;
        default:
            setAvailabilityMessage = 'in stock';
    }
    return setAvailabilityMessage;
};

export const getDeliveryDateAnalytics = (
    shipToHomeOrStore,
    productDetails,
    skuId,
    selectedProduct,
    pricingDetails,
    selectedSkuIds,
    fromMiniPDP = false,
    miniPDPProductAvailibilityData = {}
) => {
    const { defaults, original, fpac, mapPrice, isCouponAmount } = pricingDetails;
    const productPromiseDate = shipToHomeOrStore?.expDeliveryDate || '';
    const productInStock = getAvailabilityStatus(shipToHomeOrStore);
    const productPPID = get(productDetails, 'id', '');
    const productName = get(productDetails, 'name', '');
    const productLotId = [get(selectedProduct, '[0].id', '')];
    const productTruckable = selectedProduct?.[0]?.shipping?.truckable ? 'yes' : 'no';
    const productSKU =
        skuId || (selectedSkuIds && selectedSkuIds.length > 0 && selectedSkuIds[0]) || '';
    const decimalRounding = (value) => parseFloat(Math.round(value * 100) / 100).toFixed(2);
    const productPriceWithCoupon = !mapPrice
        ? isCouponAmount && fpac && fpac.length
            ? decimalRounding(trim(fpac[0].amount.min, '$'))
            : ''
        : '';
    const productCurrentSellingPrice = !mapPrice
        ? defaults && defaults.length
            ? decimalRounding(
                  trim(
                      defaults?.replace(/,/g, '').split('- ')[defaults.split('- ').length - 1],
                      '$'
                  )
              )
            : '0.00'
        : '';
    const productListPrice = !mapPrice
        ? original && original.length
            ? decimalRounding(
                  trim(
                      original?.replace(/,/g, '').split('- ')[original.split('- ').length - 1],
                      '$'
                  )
              )
            : productCurrentSellingPrice
        : '';
    const productDeliveryDayType = get(shipToHomeOrStore, 'deliveryMessage', false)
        ? getDeliveryDateType(shipToHomeOrStore.deliveryMessage)
        : '';
    const productDeliveryDays =
        productDeliveryDayType === 'single' && get(shipToHomeOrStore, 'rawDeliveryDateStart', '')
            ? shipToHomeOrStore.difference_In_Days
            : '';
    const productInStockData = productPromiseDate ? productInStock : 'not Available';
    const miniPDPProductInStockData = getAvailabilityStatus(miniPDPProductAvailibilityData);
    return {
        productPPID,
        productName,
        productLotId,
        productSKU,
        productListPrice,
        productCurrentSellingPrice,
        productInStock: fromMiniPDP ? miniPDPProductInStockData : productInStockData,
        productDeliveryDayType: fromMiniPDP ? 'na' : productDeliveryDayType,
        productDeliveryDays: fromMiniPDP ? 'na' : productDeliveryDays,
        productPromiseDate:
            productDeliveryDayType === 'single' ? productPromiseDate : fromMiniPDP ? 'na' : '',
        productPriceWithCoupon,
        productTruckable,
    };
};
